@if (device() || deviceRule()) {
  <h4
    class="font-semibold text-base flex items-center p-4 min-w-[247px]"
    [class.h-6]="status() === eEntityStatus.Archived"
  >
    @if (status() === eEntityStatus.Archived) {
      <i class="icon-add-to-archive text-ui-gray-100 text-3xl"></i>
    }
    @if (status() === eEntityStatus.Paused) {
      <i class="icon-offline text-ui-gray-100 text-3xl"></i>
    }
    @if (status() === 'active') {
      @if (incidents()) {
        @if (!incidents()!.critical && !incidents()!.major && !incidents()!.minor) {
          <i class="icon-CheckCircleRounded text-ui-green-light text-3xl">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        }
        @if (incidents()!.critical) {
          <i class="icon-alert text-ui-red-50 text-3xl"></i>
        }
        @if ((incidents()!.major || incidents()!.minor) && !incidents()!.critical) {
          <i class="icon-warning text-ui-yellow-100 text-3xl"></i>
        }
      }
      @if (!deviceRule() && severity()) {
        @if (severity() === eIncidentSeverity.CRITICAL) {
          <i class="icon-alert text-ui-red-50 text-3xl"></i>
        }
        @if (severity() === eIncidentSeverity.MAJOR || severity() === eIncidentSeverity.MINOR) {
          <i class="icon-warning text-ui-yellow-100 text-3xl"></i>
        }
      }
    }
    <div class="flex flex-col ml-1.5 overflow-hidden">
      <a class="block text-sm avs-truncate">{{ name() }}</a>
      @if (deviceName()) {
        <a [routerLink]="['/devices', locationId, id()]">
          <span class="text-xs text-ui-gray-100 avs-truncate leading-tight hover:underline">{{ deviceName() }}</span>
        </a>
      }
    </div>
  </h4>
}
